import apiClient from '@u/apiClient'
import { resolve } from 'chart.js/helpers'
import { reject } from 'lodash-es'

// import router from "@/router";

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  async fetchNewInvoiceSendRecord({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get('model/new?model=invoiceSendRecord')
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storeInvoiceSendRecord({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `invoicing/${payload.invoice_id}/send-record`,
          payload.send_record
        )
        .then((response) => {
          // processSuccessCallback(payload)
          if (response.status === 200) {
            console.log(response.data.invoice)
            commit('setInvoice', response.data.invoice)
            commit('setInvoiceMetadata', response.data.metadata)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  async addItemsToInvoice({ commit }, payload) {
    await apiClient
      .post(`invoicing/${payload.invoice_id}/add-items`, payload.data)
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          processSuccessCallback(payload)
          resolve(response.data)
        }
      })
      .catch((reason) => {
        reject(reason)
      })
  },
  addItemDossierToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`invoicing/${payload.invoice_id}/item-dossier`, payload.data)
        .then(async (response) => {
          await commit('setInvoice', response.data.invoice)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addItemDossiersToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `invoicing/${payload.invoice_id}/add-items-dossiers`,
          payload.data
        )
        .then(async (response) => {
          if (response.status === 200) {
            await commit('setInvoice', response.data.invoice)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchAutomationsItems: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`invoicing/${payload.invoice_id}/automations-items`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchDossierItems: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`invoicing/${payload.invoice_id}/dossier-items`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async addPackToInvoice({ commit }, payload) {
    await apiClient
      .post(`invoicing/${payload.invoice_id}/add-packs`, payload.data)
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  // ci dessous devrait disparaitre
  async updateInvoiceItem({ commit }, payload) {
    await apiClient
      .put(`invoicing/add-item-fast/${payload.invoice_id}`, payload.content)
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  // ci dessous devrait disparaitre
  async updateInvoiceDossierItem({ commit }, payload) {
    await apiClient
      .put(`invoicing/add-item-fast/${payload.invoice_id}`, {
        dossier_id: payload.dossier_id,
        item_dossier_id: payload.dossier_item_id
      })
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  // ci dessous devrait disparaitre
  async updateMultipleInvoiceItems({ commit }, payload) {
    await apiClient
      .put(`invoicing/add-multiple-items/${payload.invoice_id}`, payload.items)
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },

  updateSingleInvoiceItem: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .put(
          `invoicing/${payload.invoice_id}/invoice-item/${payload.id}`,
          payload.invoice_item,
          {
            params: {
              for_invoice: payload.for_invoice
            }
          }
        )
        .then((response) => {
          if (payload.for_invoice) {
            commit('setInvoice', response.data.invoice)
          } else {
            commit('setInvoiceItemIndex', response.data.invoice_items)
            commit('setInvoiceItemsMetadata', response.data.metadata)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion
}
